module.exports = __webpack_public_path__ + "img/841.17ac06ea.png";